import React, { useState } from 'react';
import Popup from '../Modals/Popup';

export default function ReschedulePopup({ leadData, button, updateLeadData }) {

  const [showReschedulePopup, setShowReschedulePopup] = useState(false);
  const [newAppointment, setNewAppointment] = useState(leadData.appointment_date + "T" + leadData.time24);


  const openReschedulePopup = () => {
    setShowReschedulePopup(true);
  };

  const closeReschedulePopup = () => {
    setShowReschedulePopup(false);
  };

  const updateReschedule = () => {
    const d = new Date(Date.parse(newAppointment));
    var values = {
      "id":leadData.id,
      "appointment_date":d.toISOString()
    };

    console.log(newAppointment,values);

    updateLeadData(leadData.id,'appointment_date',d.toISOString());

    closeReschedulePopup();
  };

  return (
    <>
      <div onClick={openReschedulePopup}>{button}</div>

      <Popup action={showReschedulePopup ? 'open' : ''}>
        <h2 className="headingedit mb-1">Reschedule</h2>
        
        <label htmlFor="start-time">Date & Time:</label>
        <input className='editnote-textarea input'
          id="start-time" 
          type="datetime-local"
          onChange={(e) => setNewAppointment(e.target.value)}
          value={newAppointment}
        />
        <button onClick={updateReschedule} className="editbtn">
          Reschedule
        </button>
      </Popup>
    </>
  );
}
